import { EditableText } from "@blueprintjs/core";
import { IWidgetProps } from "decorator-form";
import React from "react";

interface IEditableTextProps extends IWidgetProps<string> {
	multiline?: boolean;
	placeholder?: string;
}

export const EditableTextWidget: React.SFC<IEditableTextProps> = ({ disabled, label, multiline, onChange, placeholder, value }) => (
	<EditableText
		confirmOnEnterKey={true}
		defaultValue={value}
		disabled={disabled}
		multiline={multiline}
		onConfirm={(v) => onChange(v)}
		placeholder={placeholder || label}
	/>
);



// WEBPACK FOOTER //
// ./src/common/form/widgets/EditableTextWidget.tsx